import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intake
export const submitIntake = (data) => api.post('/api/intake', data);

// Contact
export const submitContact = (data) => api.post('/api/contact', data);

// Admin
export const getCases = (params) => api.get('/api/admin/cases', { params });
export const getCase = (id) => api.get(`/api/admin/cases/${id}`);
export const updateCase = (id, data) => api.patch(`/api/admin/cases/${id}`, data);
export const getStats = () => api.get('/api/admin/stats');
export const getContacts = (params) => api.get('/api/admin/contacts', { params });

export default api;
